module.exports = __webpack_public_path__ + "static/media/11NEPAD8.a690691f.jpg";